// Used for editing pop up
const FILE_TYPES = {
    BULK: 'bulk_function',
    ALL: 'all',
    RANGE: 'range_function',
};

export default FILE_TYPES;
